import React, { useState, useEffect } from 'react';
import { FaCrown, FaCoins } from 'react-icons/fa';
import './Credits.css';

const Credits = () => {
  const [credits, setCredits] = useState('0');
  const [subscription, setSubscription] = useState(null);

  const updateUserInfo = () => {
    const userProfile = localStorage.getItem('userProfile');
    if (userProfile) {
      try {
        const profile = JSON.parse(userProfile);
        
        // Check for active subscription
        const hasActiveSubscription = profile.subscription && 
          profile.subscription.status === 'active' &&
          new Date(profile.subscription.endDate) > new Date();

        if (hasActiveSubscription) {
          setSubscription({
            package: profile.subscription.package,
            daysLeft: Math.ceil((new Date(profile.subscription.endDate) - new Date()) / (1000 * 60 * 60 * 24))
          });
          setCredits('unlimited');
        } else {
          setSubscription(null);
          setCredits(profile.credits || '0');
        }
      } catch {
        setCredits('0');
        setSubscription(null);
      }
    } else {
      setCredits('0');
      setSubscription(null);
    }
  };

  useEffect(() => {
    // Initial update
    updateUserInfo();

    // Listen for storage changes
    const handleStorageChange = (e) => {
      if (!e.key || e.key === 'userProfile') {
        updateUserInfo();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('storage-local', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('storage-local', handleStorageChange);
    };
  }, []);

  if (subscription) {
    return (
      <div className="credits subscription-active" title={`${subscription.package} - ${subscription.daysLeft} days left`}>
        <FaCrown className="subscription-icon" />
        <div className="subscription-info">
          <div className="subscription-package">{subscription.package}</div>
          <div className="subscription-days">{subscription.daysLeft}d left</div>
        </div>
      </div>
    );
  }

  return (
    <div className="credits" title={`Available Credits: ${credits}`}>
      <FaCoins className="credits-icon" />
      <div className="credits-info">
        <div className="credits-value">{credits}</div>
        <div className="credits-text">Credits</div>
      </div>
    </div>
  );
};

export default Credits; 